const mobileMenu = {
  root: null,
  navTrigger: null,
  mainMenu: null,
  parents: [],
  backButtons: [],
  searchTrigger: null,
  mainSearch: null,

  submenuActive: function (e) {
    if (e.target.classList.contains("parent")) {
      e.preventDefault();
    }

    const activeSubmenu = document.querySelector(
      ".main-header-nav .nav-submenu.active"
    );
    if (activeSubmenu) {
      activeSubmenu.classList.remove("active");
    }

    const submenuToActivate = this.querySelector(".nav-submenu");
    if (submenuToActivate) {
      submenuToActivate.classList.add("active");
    }
  },

  submenuBack: function (e) {
    e.stopPropagation();

    const parent = this.closest(".nav-submenu");

    parent.classList.remove("active");
  },

  mainMenuToggle: function () {
    const activeSubmenu = document.querySelector(
      ".main-header-nav .nav-submenu.active"
    );

    if (activeSubmenu) {
      activeSubmenu.classList.remove("active");
    }

    this.searchTrigger.classList.remove("active");
    this.searchTrigger.classList.remove("active");
    this.root.classList.remove("menu-active");
    this.navTrigger.classList.toggle("active");
    this.mainMenu.classList.toggle("active");
    this.root.classList.toggle("mobile-menu-active");
  },

  handleClickOutside: function (e) {
    if (
      !this.mainMenu.contains(e.target) &&
      !this.navTrigger.contains(e.target) &&
      document.body.classList.contains("menu-active")
    ) {
      this.mainMenuToggle();
    }
  },

  toggleSearch: function (e) {
    if (this.mainSearch.contains(e.target)) {
      return;
    }

    this.navTrigger?.classList.remove("active");
    this.mainMenu?.classList.remove("active");
    this.root.classList.remove("mobile-menu-active");
    this.searchTrigger.classList.toggle("active");
    this.root.classList.add("menu-active");

    if (this.searchTrigger.classList.contains("active")) {
      this.root.classList.add("menu-active");

      const searchField = document.querySelector(
        ".main-search-field .aa-Input"
      );

      if (searchField) {
        searchField.focus();
      }
    } else {
      this.root.classList.remove("menu-active");
    }
  },

  disableSearch: function () {
    if (!this.searchTrigger.classList.contains("active")) {
      return;
    }

    this.searchTrigger.classList.remove("active");
    this.root.classList.remove("menu-active");
  },

  handleClickOutsideSearch: function (e) {
    if (
      !this.searchTrigger.contains(e.target) &&
      !this.mainSearch.contains(e.target) &&
      this.root.classList.contains("menu-active")
    ) {
      this.disableSearch();
    }
  },

  init: function () {
    this.root = document.getElementsByTagName("html")[0];
    this.navTrigger = document.querySelector(".main-header .main-nav-trigger");
    this.mainMenu = document.querySelector(".main-header .main-header-nav");
    this.backButtons = document.querySelectorAll(
      ".main-header .nav-submenu-back"
    );
    this.searchTrigger = document.querySelector(".main-search-trigger");
    this.mainSearch = document.querySelector(".main-search");

    const submenus = document.querySelectorAll(".main-header .parent");

    submenus.forEach((submenu) => {
      this.parents.push(submenu.parentNode);
    });

    this.parents.forEach((parent) => {
      parent.addEventListener("click", this.submenuActive);
    });

    this.backButtons.forEach((backButton) => {
      backButton.addEventListener("click", this.submenuBack);
    });

    // The nav and its trigger are not rendered when the menus are empty.
    if (this.navTrigger && this.mainMenu) {
      this.navTrigger.addEventListener(
        "click",
        this.mainMenuToggle.bind(this)
      );

      document.addEventListener("click", this.handleClickOutside.bind(this));
    }

    this.searchTrigger.addEventListener("click", this.toggleSearch.bind(this));

    document.addEventListener(
      "click",
      this.handleClickOutsideSearch.bind(this)
    );
  },

  kill: function () {
    if (this.parents.length) {
      this.parents.forEach((parent) => {
        parent.removeEventListener("click", this.submenuActive);
      });

      this.parents = [];
    }

    if (this.backButtons.length) {
      this.backButtons.forEach((backButton) => {
        backButton.removeEventListener("click", this.submenuBack);
      });

      this.backButtons = [];
    }

    if (this.navTrigger) {
      this.navTrigger.removeEventListener("click", this.mainMenuToggle);
    }

    document.removeEventListener("click", this.handleClickOutside.bind(this));
  },
};

export default mobileMenu;
